import { EnterpriseSearchService, ServiceType } from '@sabstravtech/obtservices/angular';
import { CabHireEnterpriseSearchInterface } from '@sabstravtech/obtservices/base';
import { Component, Input } from '@angular/core';

import { ProductLoadingScreen } from './product-loading-screen';

@Component({
  selector: 'app-taxi-loading-screen',
  templateUrl: './taxi-loading-screen.component.html',
  styleUrls: [],
  standalone: false
})
export class TaxiLoadingScreenComponent extends ProductLoadingScreen<CabHireEnterpriseSearchInterface> {
  @Input() animated = true;
  constructor(service: EnterpriseSearchService) {
    super(service, service.searches[ServiceType.Cab]);
  }
}
